import { createNamespacedHelpers } from 'vuex';

const historyMapper = createNamespacedHelpers('history');
const historyImageMapper = createNamespacedHelpers('history/image');
const historyModelMapper = createNamespacedHelpers('history/model');

export default {
	name: 'RetrainModal',

	components: {
		HistoryIndex: () => import('../HistoryIndex/HistoryIndex.vue'),
		RetrainImages: () => import('../RetrainImages/RetrainImages.vue'),
	},

	props: {
		retrainModalId: String,
	},
	data() {
		return {
			ok: true,
			historyImageModalId: 'ModalIdfromRetrainModal',
		};
	},

	computed: {
		...historyMapper.mapState(['noCheckBox']),
		...historyImageMapper.mapState(['retrainingImages']),
		...historyModelMapper.mapState(['model']),

		isModalVisible: {
			get() {
				return this.$store.state.history.isModalVisible;
			},
			set(value) {
				this.$store.dispatch('history/showFormModal', value);
			},
		},

		quickRetainDisabled() {
			return (
				this.retrainingImages?.length === 0 ||
				this.model === 'holes_patchcore.pytorch' ||
				this.model === 'opencv_holes'
			);
		},
	},

	methods: {
		...historyMapper.mapActions(['showFormModal', 'hideFormModal']),
		...historyMapper.mapMutations(['UPDATE_NO_CHECKBOX']),
		...historyImageMapper.mapActions(['retrain']),

		onClickListofRetraining() {
			this.ok = true;
			this.UPDATE_NO_CHECKBOX(false);
		},
		onClickListofImages() {
			this.ok = false;
			this.UPDATE_NO_CHECKBOX(true);
		},

		hideModal() {
			this.UPDATE_NO_CHECKBOX(false);
			this.hideFormModal();
			this.$eventBus.$emit('force-update');
		},

		async onQuickRetrain() {
			await this.retrain();
			this.$eventBus.$emit('force-update');
		},
	},
};
